<template>
  <div>
    <el-table class="table_box pc_table_box" :data="pageData" style="width: 100%"
              v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" :row-style="{ height: '59px' }"
    >
      <el-table-column prop="id" :label="$t('order_id')" width="100px"></el-table-column>
      <el-table-column prop="time" :label="$t('time')" width="120px">
        <template slot-scope="scope">
          <div v-html="scope.row.time"></div>
        </template>
      </el-table-column>
      <el-table-column prop="deal" :label="$t('contract2')" width="140px">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.deal }}</div>
            <div class="symbol_down">{{$t('perpetual')}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="open" :label="$t('direction')" width="100px">
        <template slot-scope="scope">
          <div :style="{'color':scope.row.open===1?'rgba(46, 189, 133, 1) !important':'rgba(239, 69, 74, 1) !important'}">
            <span v-if="scope.row.open===1">{{$t("open")}}</span>
            <span v-else>{{$t('close')}}</span>
            <span v-if="scope.row.type==1">{{$t("long")}}</span>
            <span v-if="scope.row.type==2">{{$t("short")}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="orderType" :label="$t('type')" width="100px" align="center">
      </el-table-column>
      <el-table-column prop="price2" :label="$t('trigger_price')" width="140px" align="center">
        <template scope="scope">
          <span v-html="scope.row.price3"></span>
        </template>
      </el-table-column>
      <el-table-column prop="price3" :label="$t('order_price2')" width="140px" align="left">
        <template slot-scope="scope">
          <span v-html="scope.row.price2"></span>
        </template>
      </el-table-column>

      <el-table-column prop="price" :label="$t('quantity')" width="120px" align="center"></el-table-column>
      <el-table-column prop="price" :label="$t('trade_quantity')" width="120px" align="center"></el-table-column>
      <el-table-column prop="operate" :label="$t('action')" align="center">
        <template slot-scope="scope">
          <div class="operate_box" v-if="showOrder">
            <div class="operate_2" style="padding: 0 0;" @click="cancelShowDialog(scope.row)"><span
                style="color: #A5D63F">{{ $t("revoke") }}</span></div>
          </div>
          <div v-if="!showOrder">
            --
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="table_box mobile_table_box"
              :data="pageData" style="width: 100%;padding: 0;margin-bottom: 20px"
              ref="table"
              @row-click="handleRowClick"
    >
      <el-table-column type="expand" :label="'#'">
        <template slot-scope="props">
          <div class="data_content" style="margin-top: 0">
            <div class="row">
              <div class="item">
                <div class="title">{{$t("direction")}}</div>
                <div class="value">
                  {{props.row.orderType}}
                </div>
              </div>
              <div class="item">
                <div class="title">{{$t('trigger_price')}}</div>
                <div class="value">
                  <span v-html="props.row.price3"></span>
                </div>
              </div>
              <div class="item">
                <div class="title right">{{ $t("quantity") }}</div>
                <div class="value right">{{ props.row.price }}</div>
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="item">
                <div class="title">{{ $t('trade_quantity') }}</div>
                <div class="value">{{ props.row.price }}</div>
              </div>
              <div class="item">
                <div class="title right">{{ $t('action') }}</div>
                <div class="value right">
                  <div class="operate_box" v-if="showOrder">
                    <div class="operate_2" style="padding: 0 0;" @click="cancelShowDialog(props.row)"><span
                        style="color: #A5D63F">{{ $t("revoke") }}</span></div>
                  </div>
                  <div v-if="!showOrder">
                    --
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deal" :label="$t('contract2')" width="100"></el-table-column>
      <el-table-column prop="time" :label="$t('time')">
        <template slot-scope="scope">
          <span v-html="scope.row.time"></span>
        </template>
      </el-table-column>
      <el-table-column prop="orderType" :label="$t('direction')" width="60">
        <template slot-scope="props">
          <div :style="{'color':props.row.open===1?'rgba(46, 189, 133, 1) !important':'rgba(239, 69, 74, 1) !important'}">
            <span v-if="props.row.open===1">{{$t('open')}}</span>
            <span v-else>{{$t('close')}}</span>
            <span v-if="props.row.type==1">{{$t('long')}}</span>
            <span v-if="props.row.type==2">{{$t('short')}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="price2" :label="$t('order_price2')" align="right">
        <template scope="scope">
          <span v-html="scope.row.price2"></span>
        </template>
      </el-table-column>
    </el-table>
      <el-pagination @prev-click="prevClick()"
                     @next-click="nextClick()"
                     :page-size="pageSize"
                     :current-page.sync="currentPage"
                     layout="prev, pager, next"
                     style="margin-bottom: 300px"
                     align="right"
                     :total="tableData1.length"/>

    <el-dialog :modal="false" style="margin-top: 24vh" :show-close="false" :visible.sync="dialogVisible">
      <div class="text_box">
        {{ $t('confirm_revoke_order') }}
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
        <el-button class="cancel_box" @click="dialogVisible = false">{{ $t("cancel") }}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import {
  createAndCall,
  createLeadingContractAndCall,
  createLeadingContractAndSend, createOrderBookAndCall, createPerpOptionAndCall, createTradeAndCall,
  getContractWithCache,
  getErc20Info, getSelectTokenInfo
} from "../utils/contract";
import {Contract, Method} from "../config/const";
import {isMobile, transBig2number, transTime2Date} from "../utils/functions";
import {getAccount} from "../utils/wallet";
import {registerMessage, removeMessage} from "../utils/message";

export default {
  name: "activate1",
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      tableData1: [],
      currentPage: 1,
      loading: false,
      dialogVisible: false,
      selectRow: undefined,
      showOrder: false,
      orderBook: "",
      pageData:[],
      pageSize:10
    }
  },
  created() {
    // this.init()
  },
  mounted() {
    registerMessage(this.updateMessage)
  },
  unmounted() {
    removeMessage(this.updateMessage)
  },
  watch:{
    currentPage(val){
      this.setPage(val)
    }
  },
  methods: {
    setPage(val){
      let start=(val - 1) * this.pageSize;
      this.pageData=this.tableData1.slice(start,start+this.pageSize)
    },
    async init() {
      console.log("init", 1);
      this.loading = true;

      let tokenInfo = await getSelectTokenInfo(this.token);
      if (!tokenInfo) {
        return;
      }
      this.orderBook = tokenInfo.orderBook;
      let data = await this.getOrders()
      this.tableData1=[];
      this.tableData1.push(...data);
      let info = await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.contractAddress]],3600000,createAndCall);
      let account = await getAccount();
      if (info.traderAddress.toString().toLowerCase() === account.toString().toLowerCase()) {
        this.showOrder = true;
      }
      this.currentPage=1;
      this.setPage(1)

      this.loading = false;

    },
    updateMessage(msg, data) {
      this.init()
    },
    handleRowClick(row){
      this.$refs.table.toggleRowExpansion(row)
    },
    prevClick(e) {
      console.log(e)
      this.currentPage--
    },
    nextClick() {
      this.currentPage++
    },
    async cancel() {
      let tx = await createLeadingContractAndSend(this.contractAddress, Method.cancelOrders, [[this.selectRow.order]]);
      if (tx) {
        this.$emit("refresh-data");
      }
      this.init()
    },
    async getOrders() {
      if (!this.contractAddress) {
        return [];
      }
      let selectToken = await getSelectTokenInfo(this.token);
      let orderIds = await createOrderBookAndCall(this.orderBook, Method.getUserLimitOrdersID, this.token, this.contractAddress)
      let orders = await createTradeAndCall(selectToken.tradeAgent, Method.getLimitOrders, orderIds)
      let targetOrders = await createTradeAndCall(selectToken.tradeAgent, Method.getTriggerConditions, orderIds)
      let data = [];
      for (let i in orders) {
        let targetOrder = targetOrders[i];
        data.push({
          id:"#"+orderIds[i].toString(),
          order: orderIds[i].toString(),
          deal: selectToken.symbol + "-" + orders[i].name,
          coin: selectToken.symbol,
          orderType: this.getOrderType(orders[i], targetOrder),
          type: orders[i].direct,
          time: transTime2Date(parseInt(orders[i].startTime), true),
          price: transBig2number(orders[i].amount)+" "+orders[i].name,
          price2: this.getLimitPrice(orders[i], targetOrders[i]), //委托价格
          price3: this.getTargetPrice(orders[i], targetOrders[i]), //触发价格
          pan: "",
          open: orders[i].offset,
          name: selectToken.symbol,
          timePrice: transBig2number(orders[i].tradingFee)
        })
      }
      return data.reverse();
    },
    getOrderType(order, targetOrder) {
      if (order.orderType.toString() == "21") {
        return this.$t('market_order')
      } else if (order.orderType.toString() == "11") {
        if (targetOrder.gainTriggerPrice.toString() != "0" && targetOrder.lossTriggerPrice.toString() != "0") {
          return this.$t('both_sides_order')
        } else {
          return this.$t('one_side_order')
        }
      } else {
        return this.$t('limit_order2')
      }
    },
    //触发价格
    getTargetPrice(order, target) {
      if(order.orderType!=11){
        return "--";
      }
      let html="";
      let has=false;
      if(target.gainTriggerPrice.toString()!="0"){
        html+=transBig2number(target.gainTriggerPrice)
        has=true;
      }
      if(target.lossTriggerPrice.toString()!="0"){
        html+=(has?"<br/>":"")+transBig2number(target.lossTriggerPrice)
      }

      return html;
    },
    //委托价格
    getLimitPrice(order, target) {
      if(order.orderType==21){
        return this.$t('market_order')
      }else if(order.orderType==11) {
        let html = "";
        let has = false;
        if (target.gainTriggerPrice.toString() != "0") {
          if(target.gainLimitPrice.toString()!="0"){
            html += transBig2number(target.gainLimitPrice)
          }else{
            html+="市价"
          }
          has = true;
        }
        if (target.lossTriggerPrice.toString() != "0") {
          if(target.lossLimitPrice.toString()!=0){
            html += (has ? "<br/>" : "") + transBig2number(target.lossLimitPrice)
          }else{
            html += (has ? "<br/>" : "") + "市价";
          }
        }
        return html;
      }else{
        return transBig2number(order.targetPrice)
      }
    },
    cancelShowDialog(row) {
      this.selectRow = row;
      this.dialogVisible = true;
    },
    ok1() {
      this.cancel(this.selectRow)
      this.dialogVisible = false;
    }
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 18px 20px !important;

}

::v-deep .el-dialog__footer {
  padding: 0px 24px 22px !important;
}

.text_box {
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
}

::v-deep .el-dialog {
  width: 380px !important;
}

@media (max-width: 750px) {
  ::v-deep .el-dialog {
    width: 80% !important;
  }
  .data_content {
    margin-left: 15px;
    margin-right: 15px;

    .row {
      display: flex;
      //padding-top: 18px;
      //padding-bottom: 18px;
      //padding-left: 20px;
      //padding-right: 20px;
    }

    .item {
      flex: 1;

      .title {
        font-size: 13px;
        font-weight: 400;
        letter-spacing: -0.4px;
        line-height: 18.82px;
        color: rgba(128, 128, 128, 1);
      }

      .value {
        font-family: "Gilroy";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.4px;
        line-height: 14.12px;
        color: rgba(255, 255, 255, 1);
        margin-top: 3px;
      }

      .right {
        text-align: right;
      }

      .operate_box {
        justify-content: end !important;
      }
    }
  }

}

::v-deep .el-table .cell {
  line-height: revert;
  padding-left: 0px;
}

::v-deep .el-table th.el-table__cell > .cell {
  padding-left: 0px;
}

.symbol_down {
  width: 32px;
  height: 16px;
  opacity: 1;
  border-radius: 2px;
  background: rgba(38, 40, 44, 1);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14.12px;
  color: rgba(174, 177, 184, 1);
  text-align: center;
  vertical-align: middle;
  margin-top: 2px;
}
.long{
  color:rgba(46, 189, 133, 1) !important;
}
.short{
  color:rgba(239, 69, 74, 1) !important;
}
</style>
<style>
.el-table, .el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}
</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
